export const DEFAULT_STOREFRONT_THEME = "modern-farmhouse";
export const DEFAULT_STOREFRONT_DECORATION_LEVEL = "balanced";

export const STOREFRONT_THEME_ASSET_ROOT = "/storefront-themes";
const SHARED_THEME_ASSET_ROOT = `${STOREFRONT_THEME_ASSET_ROOT}/shared`;

const SHARED_THEME_ASSETS = {
  avatarFrames: {
    "barnwood-frame": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/barnwood-frame.svg`,
    "fence-rail": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/fence-rail.svg`,
    "fieldline-oval": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/fieldline-oval.svg`,
    "leather-tag": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/leather-tag.svg`,
    "metal-badge": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/metal-badge.svg`,
    "minimal-badge": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/minimal-badge.svg`,
    "rope-circle": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/rope-circle.svg`,
    "wheat-crest": `${SHARED_THEME_ASSET_ROOT}/avatar-frames/wheat-crest.svg`,
  },
  badges: {
    availableNow: `${SHARED_THEME_ASSET_ROOT}/badges/available-now.svg`,
    farmFresh: `${SHARED_THEME_ASSET_ROOT}/badges/farm-fresh.svg`,
    handmade: `${SHARED_THEME_ASSET_ROOT}/badges/handmade.svg`,
    madeToOrder: `${SHARED_THEME_ASSET_ROOT}/badges/made-to-order.svg`,
    plants: `${SHARED_THEME_ASSET_ROOT}/badges/plants.svg`,
  },
  decorations: {
    leafyCorner: `${SHARED_THEME_ASSET_ROOT}/decorations/leafy-corner.svg`,
    paperEdge: `${SHARED_THEME_ASSET_ROOT}/decorations/paper-edge.svg`,
    vineFrame: `${SHARED_THEME_ASSET_ROOT}/decorations/vine-frame.svg`,
    watercolorWash: `${SHARED_THEME_ASSET_ROOT}/decorations/watercolor-wash.svg`,
    wheatCluster: `${SHARED_THEME_ASSET_ROOT}/decorations/wheat-cluster.svg`,
    woodEdge: `${SHARED_THEME_ASSET_ROOT}/decorations/wood-edge.svg`,
  },
  dividers: {
    heart: `${SHARED_THEME_ASSET_ROOT}/dividers/divider-heart.svg`,
    leaf: `${SHARED_THEME_ASSET_ROOT}/dividers/divider-leaf.svg`,
    line1: `${SHARED_THEME_ASSET_ROOT}/dividers/divider-line-1.svg`,
    line2: `${SHARED_THEME_ASSET_ROOT}/dividers/divider-line-2.svg`,
    line3: `${SHARED_THEME_ASSET_ROOT}/dividers/divider-line-3.svg`,
    line4: `${SHARED_THEME_ASSET_ROOT}/dividers/divider-line-4.svg`,
  },
  icons: {
    badgeStar: `${SHARED_THEME_ASSET_ROOT}/icons/badge-star.svg`,
    checkCircle: `${SHARED_THEME_ASSET_ROOT}/icons/check-circle.svg`,
  },
  ui: {
    selectedCardBorder: `${SHARED_THEME_ASSET_ROOT}/ui/selected-card-border.svg`,
    unselectedIndicator: `${SHARED_THEME_ASSET_ROOT}/ui/unselected-indicator.svg`,
  },
};

export const STOREFRONT_AVATAR_FRAMES = [
  {
    value: "wheat-crest",
    label: "Wheat Crest",
    description: "Warm handmade harvest frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["wheat-crest"],
  },
  {
    value: "fence-rail",
    label: "Fence Rail",
    description: "Clean farmhouse frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["fence-rail"],
  },
  {
    value: "fieldline-oval",
    label: "Fieldline Oval",
    description: "Fresh green garden frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["fieldline-oval"],
  },
  {
    value: "leather-tag",
    label: "Leather Tag",
    description: "Vintage country label frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["leather-tag"],
  },
  {
    value: "barnwood-frame",
    label: "Barnwood",
    description: "Rustic wood storefront frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["barnwood-frame"],
  },
  {
    value: "rope-circle",
    label: "Rope Circle",
    description: "Simple homestead circle frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["rope-circle"],
  },
  {
    value: "minimal-badge",
    label: "Minimal Badge",
    description: "Quiet clean profile badge.",
    asset: SHARED_THEME_ASSETS.avatarFrames["minimal-badge"],
  },
  {
    value: "metal-badge",
    label: "Metal Badge",
    description: "Crisp practical badge frame.",
    asset: SHARED_THEME_ASSETS.avatarFrames["metal-badge"],
  },
];

export const STOREFRONT_AVATAR_FRAME_VALUES = STOREFRONT_AVATAR_FRAMES.map(
  (frame) => frame.value
);

export const STOREFRONT_DECORATION_LEVELS = [
  {
    value: "simple",
    label: "Simple",
    description: "Cleaner pages with fewer decorative accents.",
  },
  {
    value: "balanced",
    label: "Balanced",
    description: "Recommended mix of polish and readability.",
  },
  {
    value: "decorated",
    label: "Decorated",
    description: "Richer cards, dividers, and theme accents.",
  },
];

export const STOREFRONT_DECORATION_LEVEL_VALUES =
  STOREFRONT_DECORATION_LEVELS.map((level) => level.value);

const THEME_SHARED_ASSET_DEFAULTS = {
  "boho-rustic": {
    avatarFrame: SHARED_THEME_ASSETS.avatarFrames["wheat-crest"],
    avatarFrameValue: "wheat-crest",
    divider: SHARED_THEME_ASSETS.dividers.heart,
    decorations: [
      SHARED_THEME_ASSETS.decorations.leafyCorner,
      SHARED_THEME_ASSETS.decorations.wheatCluster,
      SHARED_THEME_ASSETS.decorations.watercolorWash,
    ],
    palette: {
      accent: "#9a6a4a",
      accentDark: "#3b281b",
      paper: "#fff6e8",
      wash: "#ead0a9",
    },
  },
  "modern-farmhouse": {
    avatarFrame: SHARED_THEME_ASSETS.avatarFrames["fence-rail"],
    avatarFrameValue: "fence-rail",
    divider: SHARED_THEME_ASSETS.dividers.line1,
    decorations: [
      SHARED_THEME_ASSETS.decorations.woodEdge,
      SHARED_THEME_ASSETS.decorations.leafyCorner,
      SHARED_THEME_ASSETS.decorations.watercolorWash,
    ],
    palette: {
      accent: "#4a5a4b",
      accentDark: "#26382d",
      paper: "#fbfaf4",
      wash: "#d8d1c2",
    },
  },
  "vintage-country": {
    avatarFrame: SHARED_THEME_ASSETS.avatarFrames["leather-tag"],
    avatarFrameValue: "leather-tag",
    divider: SHARED_THEME_ASSETS.dividers.line3,
    decorations: [
      SHARED_THEME_ASSETS.decorations.paperEdge,
      SHARED_THEME_ASSETS.decorations.wheatCluster,
      SHARED_THEME_ASSETS.decorations.woodEdge,
    ],
    palette: {
      accent: "#9b6a3f",
      accentDark: "#4b321f",
      paper: "#fff0d5",
      wash: "#dcc8a1",
    },
  },
  "nature-green": {
    avatarFrame: SHARED_THEME_ASSETS.avatarFrames["fieldline-oval"],
    avatarFrameValue: "fieldline-oval",
    divider: SHARED_THEME_ASSETS.dividers.leaf,
    decorations: [
      SHARED_THEME_ASSETS.decorations.leafyCorner,
      SHARED_THEME_ASSETS.decorations.vineFrame,
      SHARED_THEME_ASSETS.decorations.watercolorWash,
    ],
    palette: {
      accent: "#2f5e3c",
      accentDark: "#173a26",
      paper: "#f4faef",
      wash: "#cfe3cc",
    },
  },
  "minimal-clean": {
    avatarFrame: SHARED_THEME_ASSETS.avatarFrames["minimal-badge"],
    avatarFrameValue: "minimal-badge",
    divider: SHARED_THEME_ASSETS.dividers.line4,
    decorations: [
      SHARED_THEME_ASSETS.decorations.paperEdge,
      SHARED_THEME_ASSETS.decorations.watercolorWash,
      SHARED_THEME_ASSETS.decorations.paperEdge,
    ],
    palette: {
      accent: "#555555",
      accentDark: "#161616",
      paper: "#ffffff",
      wash: "#eeeeee",
    },
  },
};

export const STOREFRONT_THEMES = [
  {
    value: "boho-rustic",
    id: "boho-rustic",
    name: "Boho Rustic",
    description: "Warm handmade market style with earthy farm accents.",
    bestFor: "Handmade goods, soaps, eggs, baked goods, small homesteads.",
    previewTitle: "Bree's Crafts",
    previewSubtitle: "Handmade with heart",
  },
  {
    value: "modern-farmhouse",
    id: "modern-farmhouse",
    name: "Modern Farmhouse",
    description: "Clean, neutral farm-business style for everyday local storefronts.",
    bestFor: "Farms, livestock, services, produce, general storefronts.",
    previewTitle: "BREE'S CRAFTS",
    previewSubtitle: "Handmade with heart",
  },
  {
    value: "vintage-country",
    id: "vintage-country",
    name: "Vintage Country",
    description: "Aged-paper, seed-packet, harvest-market profile style.",
    bestFor: "Farm stands, harvest goods, seed-packet feel, cozy sellers.",
    previewTitle: "Bree's Crafts",
    previewSubtitle: "Handmade with love",
  },
  {
    value: "nature-green",
    id: "nature-green",
    name: "Nature & Green",
    description: "Garden, herb, plant, produce, and homestead profile style.",
    bestFor: "Plants, herbs, gardens, produce, homestead shops.",
    previewTitle: "BREE'S CRAFTS",
    previewSubtitle: "Inspired by nature",
  },
  {
    value: "minimal-clean",
    id: "minimal-clean",
    name: "Minimal & Clean",
    description: "Simple, professional public profile style for practical sellers.",
    bestFor: "Services, hay, livestock, land share, equipment.",
    previewTitle: "BREE'S CRAFTS",
    previewSubtitle: "Handmade with heart",
  },
].map((theme) => ({
  ...theme,
  ...THEME_SHARED_ASSET_DEFAULTS[theme.id],
  availableAvatarFrames: STOREFRONT_AVATAR_FRAMES,
  defaultAvatarFrameValue: THEME_SHARED_ASSET_DEFAULTS[theme.id].avatarFrameValue,
  defaultDecorationLevel: DEFAULT_STOREFRONT_DECORATION_LEVEL,
  previewCard: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/preview-card.webp`,
  templatePreview: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/template-preview.webp`,
  desktopHero: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/desktop-hero.webp`,
  mobileHero: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/mobile-hero.webp`,
  background: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/background.webp`,
  productCardBg: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/product-card-bg.webp`,
  savePanelBg: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/save-panel-bg.webp`,
  tipsCardBg: `${STOREFRONT_THEME_ASSET_ROOT}/${theme.id}/tips-card-bg.webp`,
  decorationPrimary: THEME_SHARED_ASSET_DEFAULTS[theme.id].decorations[0],
  decorationSecondary: THEME_SHARED_ASSET_DEFAULTS[theme.id].decorations[1],
  decorationTertiary: THEME_SHARED_ASSET_DEFAULTS[theme.id].decorations[2],
  badgeAssets: SHARED_THEME_ASSETS.badges,
  iconAssets: SHARED_THEME_ASSETS.icons,
  uiAssets: SHARED_THEME_ASSETS.ui,
}));

export const STOREFRONT_THEME_VALUES = STOREFRONT_THEMES.map(
  (theme) => theme.value
);

export const isValidStorefrontTheme = (theme) =>
  STOREFRONT_THEME_VALUES.includes(theme);

export const isValidStorefrontAvatarFrame = (avatarFrame) =>
  STOREFRONT_AVATAR_FRAME_VALUES.includes(avatarFrame);

export const isValidStorefrontDecorationLevel = (level) =>
  STOREFRONT_DECORATION_LEVEL_VALUES.includes(level);

export const getStorefrontTheme = (profileOrTheme = {}) => {
  const theme =
    typeof profileOrTheme === "string"
      ? profileOrTheme
      : profileOrTheme?.storefrontTheme;

  return isValidStorefrontTheme(theme) ? theme : DEFAULT_STOREFRONT_THEME;
};

export const getStorefrontThemeConfig = (profileOrTheme = {}) => {
  const themeId = getStorefrontTheme(profileOrTheme);
  return (
    STOREFRONT_THEMES.find((theme) => theme.value === themeId) ||
    STOREFRONT_THEMES.find((theme) => theme.value === DEFAULT_STOREFRONT_THEME)
  );
};

export const getStorefrontAvatarFrame = (
  profileOrFrame = {},
  themeConfig = getStorefrontThemeConfig()
) => {
  const frame =
    typeof profileOrFrame === "string"
      ? profileOrFrame
      : profileOrFrame?.storefrontAvatarFrame;
  const fallbackFrame =
    themeConfig?.defaultAvatarFrameValue ||
    getStorefrontThemeConfig(DEFAULT_STOREFRONT_THEME).defaultAvatarFrameValue;
  return isValidStorefrontAvatarFrame(frame) ? frame : fallbackFrame;
};

export const getStorefrontAvatarFrameAsset = (
  profileOrFrame = {},
  themeConfig = getStorefrontThemeConfig()
) => {
  const frame = getStorefrontAvatarFrame(profileOrFrame, themeConfig);
  return (
    SHARED_THEME_ASSETS.avatarFrames[frame] ||
    themeConfig?.avatarFrame ||
    getStorefrontThemeConfig(DEFAULT_STOREFRONT_THEME).avatarFrame
  );
};

export const getStorefrontDecorationLevel = (profileOrLevel = {}) => {
  const level =
    typeof profileOrLevel === "string"
      ? profileOrLevel
      : profileOrLevel?.storefrontDecorationLevel;

  return isValidStorefrontDecorationLevel(level)
    ? level
    : DEFAULT_STOREFRONT_DECORATION_LEVEL;
};
